import * as React from 'react';

function SvgDownload(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.827 5.396a.7.7 0 111.4 0v14.097l4.117-3.979a.7.7 0 11.973 1.007l-5.292 5.114a.698.698 0 01-.985.011L9.742 16.52a.7.7 0 11.974-1.006l4.11 3.978V5.396zm9.91 15.047a.7.7 0 00-.7.7v3.345H6.963v-3.345a.7.7 0 10-1.4 0v4.044a.7.7 0 00.7.7h18.472a.7.7 0 00.7-.7v-4.044a.7.7 0 00-.7-.7z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgDownload;
